import {VideoDisplay, VideoDisplayType, VideoFormat, VideoFormatType} from './VideoFormat';
import {VideoLink} from './VideoLink';

export class VimeoVideo {
    public static TYPE: VideoFormatType = VideoFormat.VIMEO;
    public static DISPLAY: VideoDisplayType = VideoDisplay.IFRAME;


    public static createVideoLink(): VideoLink {
        return new VideoLink(VimeoVideo.TYPE, VimeoVideo.DISPLAY);
    }

    public static isVideoFormat(url: string): boolean {
        const regexSharedUrl = new RegExp('^(https?\\:\\/\\/)?(vimeo\\.com)\\/[0-9]+.*$');
        const regexPlayerUrl = new RegExp('^(https?\\:\\/\\/)?(player\\.)(vimeo\\.com).*$');
        return regexSharedUrl.test(url) || regexPlayerUrl.test(url);
    }
}
